import { z } from "zod";

import { zSidLabel } from "./ZSidLabel";

export const zRole = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullish(),
  createdAt: z.string(),
  updatedAt: z.string(),
  createdBy: zSidLabel.nullish(),
  updatedBy: zSidLabel.nullish(),
});

export type ZRole = z.infer<typeof zRole>;

export const zRoleSaveData = zRole.partial().pick({
  name: true,
  description: true,
});

export type ZRoleSaveData = z.infer<typeof zRoleSaveData>;
